import { NotificationDetailsResultViewModel } from './../business-entities/notification-details-result-view-model';
import { Injectable } from '@angular/core';
import { NotificationLogDataService } from './../data-services/notification-log-data.service';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { NotificationType } from '../business-entities/notification-type.model';
import { FilterNotificationRequestModel } from '../data-services/filte-notification-request-model';

@Injectable({ providedIn: 'root' })
export class NotificationLogService {
    constructor(
        private notificationLogDataService: NotificationLogDataService
    ) { }

    async getNotificationTypes(): Promise<Array<NotificationType>> {
        let notificationTypes: Array<NotificationType> = [];
        await this.notificationLogDataService.getNotificationTypes().then(response => {
            notificationTypes = response.responseObject.result as NotificationType[];
        });
        return notificationTypes;
    }

    async getNotificaionFilter(filterNotification: FilterNotificationRequestModel) {
        let notifications: Array<NotificationDetailsResultViewModel> = [];
        await this.notificationLogDataService.getNotificaionFilter(filterNotification).then(response => {
            notifications = response.responseObject.result as Array<NotificationDetailsResultViewModel>
        });
        return notifications;
    }

    markNotificationAsReadbyId(model: any): Promise<GenericResponse<any>> {
        return this.notificationLogDataService.markNotificationAsReadbyId(model);
    }
    sentShareboxInformation(dealerId:string,appointmentId:number,languageCode:string,customerNo:string): Promise<GenericResponse<any>> {
        return this.notificationLogDataService.sentShareboxInformation(dealerId,appointmentId,languageCode,customerNo);
    }
}